import { canActor } from '../domain/authorization'
import type { ActorContext } from '../domain/authorization'
import type { NotifyPort } from '@/features/messages/domain/notify'
import type { WorkItem, WorkItemPort } from '../domain/workflow'

const assignWorkItem = async (
	port: WorkItemPort,
	item: WorkItem,
	ctx: ActorContext,
	member: { id: string; name: string },
	notify: NotifyPort,
	phaseTeamId: string | null = null,
): Promise<WorkItem | null> => {
	if (!canActor('assign', item, ctx, phaseTeamId)) {
		notify.error('workItem.denyAssign')
		return null
	}
	try {
		const updated = await port.assign(item.id, member.id, ctx.actorId, ctx.actorName)
		notify.success('workItem.assigned', { name: member.name })
		return updated
	} catch {
		notify.error('workItem.assignFailed')
		return null
	}
}

export { assignWorkItem }
